import React from 'react'
import SimpleEntitiesEditor from '../../../components/simpleEntitiesEditor'
import { InfoIcon } from '../../../components/icons'
import { beautifyList } from '../../../common/utils'
import { applianceSpecialTypes } from '../../../common/appliance'


export default ({ entityName }) => (
  <SimpleEntitiesEditor entityName="applianceType" entityLabel="Appliance Type">
    <span style={{ margin: 30, opacity: 0.7 }}>
      <InfoIcon/>&nbsp;Using types {beautifyList(applianceSpecialTypes)} device types will cause some ui changes
    </span>
  </SimpleEntitiesEditor>
)
